// extracted by mini-css-extract-plugin
export default {"navButtons":"AppNavigation_navButtons__X2tt1"};